import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modalDetailAdhesionComponent from './modalDetailAdhesion.component';
import MyLoansService from '../../myLoans.service';

let modalDetailAdhesionModule = angular.module('modalDetailAdhesion', [
  uiRouter
])

.service('myLoansService', MyLoansService)

.component('modalDetailAdhesion', modalDetailAdhesionComponent)

.name;

export default modalDetailAdhesionModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalDetailAdhesion/modalDetailAdhesion.js